import { useCallback, useMemo } from 'react';

import { resolveAuditUser } from '../../helpers/auditUser';

import { TeamMemberModel } from '../../models/user.model';

import useTeamMembersQuery from '../team/useTeamMembersQuery';

export default function useAuditUserResolver() {
    const { data } = useTeamMembersQuery();
    const members = useMemo<TeamMemberModel[]>(() => data ?? [], [data]);
    const membersById = useMemo(
        () => new Map(members.map((m) => [m.id, m])),
        [members],
    );
    const resolveUser = useCallback(
        (
            userId: number | null | undefined,
            userName: string | null | undefined,
        ) => resolveAuditUser(userId, userName, membersById),
        [membersById],
    );
    return { resolveUser, members };
}
